import { ApprovalRequest } from '../models/approval-request.model';
import {
	TravelItineraryRequest,
	TravelItinerary,
} from '../models/travel-itinerary.model';
import { TravelItinerarySearch } from '../models/travel-itinerary-search.model';
import { TravelComment } from '../models/travel-comment.model';
import { DependentRequest, Dependent } from '../models/dependent.model';
import { Appointment, AppointmentRequest } from '../models/appointment.model';
import { TravelAttachmentRequest } from '../models/travel-attachment';

export class GetApprovals {
	static readonly type = '[Travel] GetApprovals';
}

export class GetRecentApprovals {
	static readonly type = '[Travel] GetRecentApprovals';
}

export class GetFinanceChargedDepartments {
	static readonly type = '[Travel] GetFinanceChargedDepartments';
}

export class ApproveRequest {
	static readonly type = '[Travel] ApproveRequest';
	constructor(public approval: ApprovalRequest) {}
}

export class DenyRequest {
	static readonly type = '[Travel] DenyRequest';
	constructor(public denial: ApprovalRequest) {}
}

export class GetDashboardTravelQueue {
	static readonly type = '[Travel] GetDashboardTravelQueue';
}

export class GetAllTravelQueues {
	static readonly type = '[Travel] GetAllTravelQueues';
}

export class GetAdministrativeQueue {
	static readonly type = '[Travel] GetAdministrativeQueue';
	constructor(public page: number) {}
}

export class GetTravelAdminQueue {
	static readonly type = '[Travel] GetTravelAdminQueue';
	constructor(public page: number) {}
}

export class GetManagerQueue {
	static readonly type = '[Travel] GetManagerQueue';
	constructor(public page: number) {}
}

export class GetMyTravel {
	static readonly type = '[Travel] GetMyTravel';
	constructor(public page: number) {}
}

export class GetItinerary {
	static readonly type = '[Travel] GetItinerary';
	constructor(public request: TravelItineraryRequest) {}
}

export class ClearItinerary {
	static readonly type = '[Travel] ClearItinerary';
}

export class GetCanEdit {
	static readonly type = '[Travel] GetCanEdit';
	constructor(public request: TravelItineraryRequest) {}
}

export class SetErrorMessage {
	static readonly type = '[Travel] SetErrorMessage';
	constructor(public errorMessage: string) {}
}

export class ClearErrorMessage {
	static readonly type = '[Travel] ClearErrorMessage';
}

export class Search {
	static readonly type = '[Travel] Search';
	constructor(public options: TravelItinerarySearch) {}
}

export class ClearSearchResults {
	static readonly type = '[Travel] ClearSearchResults';
}

export class GetMyEmployees {
	static readonly type = '[Travel] GetMyEmployees';
}

export class GetTravelers {
	static readonly type = '[Travel] GetTravelers';
}

export class SetDependents {
	static readonly type = '[Travel] SetDependents';
	constructor(public dependents: Dependent[]) {}
}

export class GetDependents {
	static readonly type = '[Travel] GetDependents';
	constructor(public request: DependentRequest) {}
}

export class SetAppointments {
	static readonly type = '[Travel] SetAppointments';
	constructor(public appointments: Appointment[]) {}
}

export class GetAppointments {
	static readonly type = '[Travel] GetAppointments';
	constructor(public request: AppointmentRequest) {}
}

export class GetTravelPurposes {
	static readonly type = '[Travel] GetTravelPurposes';
}

export class GetCurrencies {
	static readonly type = '[Travel] GetCurrencies';
}

export class AddComment {
	static readonly type = '[Travel] AddComment';
	constructor(public comment: TravelComment) {}
}

export class ResetCreateItineraryForm {
	static readonly type = '[Travel] ResetCreateItineraryForm';
}

export class CreateItinerary {
	static readonly type = '[Travel] CreateItinerary';
	constructor(public itinerary: TravelItinerary) {}
}

export class UpdateItinerary {
	static readonly type = '[Travel] UpdateItinerary';
	constructor(public itinerary: TravelItinerary) {}
}

export class UpdateTravelDependents {
	static readonly type = '[Travel] UpdateTravelDependents';
	constructor(public itinerary: TravelItinerary) {}
}

export class UpdateTravelPartners {
	static readonly type = '[Travel] UpdateTravelPartners';
	constructor(public itinerary: TravelItinerary) {}
}

export class UpdateTransportation {
	static readonly type = '[Travel] UpdateTransportation';
	constructor(public itinerary: TravelItinerary) {}
}

export class UpdateLodgings {
	static readonly type = '[Travel] UpdateLodgings';
	constructor(public itinerary: TravelItinerary) {}
}

export class UpdateOtherCosts {
	static readonly type = '[Travel] UpdateOtherCosts';
	constructor(public itinerary: TravelItinerary) {}
}

export class UpdateFinance {
	static readonly type = '[Travel] UpdateFinance';
	constructor(public itinerary: TravelItinerary) {}
}

export class UploadAttachment {
	static readonly type = '[Travel] UploadAttachment';
	constructor(public request: TravelAttachmentRequest) {}
}

export class DeleteAttachment {
	static readonly type = '[Travel] DeleteAttachment';
	constructor(public request: TravelAttachmentRequest) {}
}

export class GetTravelLegTypes {
	static readonly type = '[Travel] GetTravelLegTypes';
}

export class GetOtherCostTypes {
	static readonly type = '[Travel] GetOtherCostTypes';
}

export class GetAttachmentMetadataTypes {
	static readonly type = '[Travel] GetAttachmentMetadataTypes';
}

export class SubmitItinerary {
	static readonly type = '[Travel] SubmitItinerary';
	constructor(public itinerary: TravelItinerary) {}
}

export class CancelItinerary {
	static readonly type = '[Travel] CancelItinerary';
	constructor(public itinerary: TravelItinerary) {}
}

export class DeleteItinerary {
	static readonly type = '[Travel] DeleteItinerary';
	constructor(public itinerary: TravelItinerary) {}
}

export class GetPerDiemLinks {
	static readonly type = '[Travel] GetPerDiemLinks';
}

export class OpenAdvancedSearch {
	static readonly type = '[Travel] OpenAdvancedSearch';
}

export class CloseAdvancedSearch {
	static readonly type = '[Travel] CloseAdvancedSearch';
}
